/**
 * Converts an array of size strings into the format that DFP expects
 * @param {Array<string>} sizes - Array of size strings to convert
 * @return {Array<Array<number>>} DFP compatible list of sizes
 */
export default function buildSizeMap(sizes) {
  if (!Array.isArray(sizes)) throw new Error('Source not an array');

  return sizes.map((size) => {
    if (String(size).toLowerCase() === 'fluid') return 'fluid';

    const sizeArray = size.split(',');
    if (sizeArray.length !== 2) throw new Error('Wrong number of values');

    return sizeArray.map((item) => {
      if (Number.isNaN(item)) throw new Error('Invalid value in array map');
      return Number(item);
    });
  });
}
